import { useFindDepartment } from '@/data/Content/Departments';
import { usePriceBy } from '@/data/Content/Prices';
import { ProductType } from '@/data/types/Product';
import { useMemo } from 'react';

export const useProductsWithInfoElectronico = (products: ProductType[]) => {
	const catalogEntryIds = useMemo(() => products.map((product) => product.id), [products]);

	const { data: productsDepartments, isLoading: isLoadingProductsDepartments } = useFindDepartment(
		catalogEntryIds?.length
			? {
					catentries: catalogEntryIds.join(','),
			  }
			: undefined
	);

	const { data: productsPrices, isLoading: isLoadingProductsPrices } = usePriceBy(
		catalogEntryIds?.length
			? {
					catalogEntryId: catalogEntryIds,
			  }
			: undefined
	);

	const productsCombined = useMemo(
		() =>
			products.map((product) => {
				const isDpElectronico = Object.entries(productsDepartments?.departments ?? {}).find(
					([productId, value]) => value === 'electronicos' && product.id === productId
				);

				if (!isDpElectronico) {
					return {
						...product,
						infoElectronico: undefined,
					};
				}

				const productPrice = productsPrices?.EntitledPrice?.find(
					(price) => price.productId === product.id
				);

				return {
					...product,
					infoElectronico: {
						offerDeContado: productPrice?.UnitPrice?.at(0)?.price?.value?.toString(),
						strikedDeContado: product['x_prices.field1'],
					},
				};
			}),
		[products, productsPrices, productsDepartments]
	);

	return {
		data: productsCombined,
		isLoading: isLoadingProductsDepartments || isLoadingProductsPrices,
	};
};
